export enum AriaSort {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
  NONE = 'none',
}
